<template>
    <LayoutSub>
        <SubSection class="pb-0">
            <ListNormalPage :data="data" v-if="data" />
            <LoadingWrap v-else />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import ListNormalPage from '../../common/ListNormalPage.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';
import { getNoticeList } from '@/api';

export default {
    components: {
        LayoutSub,
        ListNormalPage,
        SubSection,
        LoadingWrap,
    },
    data() {
        return {
            data: null,
        };
    },
    async mounted() {
        this.getList();
    },
    watch: {
        async $route() {
            await this.getList();
        },
    },
    methods: {
        async getList() {
            try {
                const { paging: data } = await getNoticeList(this.$route.query);
                this.data = data;
            } catch (err) {
                if (!this.data) this.data = null;
            }
        },
    },
};
</script>
